<div class="container">
  <div class="d-flex justify-content-between row">
    <div class="col-md-8 col-12">
      <div class="fs-32 fw-semibold font-white">Welcome {{ userName }}</div>
      <div class="font-white fs-16 fw-normal">Manage memberships, classes, and performance metrics of center.</div>
    </div>
    @if(userTypeID !== 3){
    <div class="col-md-4 col-12">
      <button class="dashboard-btn d-flex align-items-center justify-content-center" (click)="onCreateCenter()">Create New Center</button>
    </div>
    }
  </div>
  <div class="mt-5">
    @if(userTypeID === 1){
    <div class="card bg-card p-3 border-radius-10">
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="d-flex flex-column flex-md-row align-items-start">
          <div [innerHtml]="SVG_ICONS.MANEGE_CONTROL_ICON() | sanitizer : 'html'"></div>
          <div class="ms-md-2 mt-2 mt-md-0">
            <div class="fs-14 fw-bold font-white">State Admin Control</div>
            <p class="font-white fs-12 fw-normal mb-0">Manage everything on state level.</p>
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-start justify-content-md-end mt-3 mt-md-0">
          <div class="d-flex align-items-start me-4 mb-2">
            <div [innerHtml]="SVG_ICONS.HOME_ICON(36, 36) | sanitizer : 'html'"></div>
            <div class="ms-2">
              <div class="fs-12 fw-normal font-gray">All Centers</div>
              <p class="font-white fs-16 fw-bold mb-0">{{ Counts?.totalCenter }}</p>
            </div>
          </div>

          <div class="d-flex align-items-start me-4 mb-2">
            <div [innerHtml]="SVG_ICONS.COACH_ARROW('var(--font-color-white)', 36, 36) | sanitizer : 'html'"></div>
            <div class="ms-2">
              <div class="fs-12 fw-normal font-gray">All Coaches</div>
              <p class="font-white fs-16 fw-bold mb-0">{{ Counts?.totalCoaches }}</p>
            </div>
          </div>

          <!-- <div class="d-flex align-items-start me-4 mb-2">
            <div [innerHtml]="SVG_ICONS.MEMBER_ICON('var(--font-color-white)', 36, 36) | sanitizer : 'html'"></div>
            <div class="ms-2">
              <div class="fs-12 fw-normal font-gray">All Students</div>
              <p class="font-white fs-16 fw-bold mb-0">{{ Counts?.totalMembers }}</p>
            </div>
          </div> -->
          <div class="mt-2 ms-md-3">
            <div tabindex="0" role="button">
              <div
                [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"
                (click)="onDashboard()"
                tabindex="0"
                (keydown.enter)="onDashboard()"
                (keydown.space)="onDashboard()"
                (keydown.tab)="onDashboard()"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }

    <div class="d-flex justify-content-end">
      <div class="search-area mt-3">
        <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
        <input type="text" class="search-input" placeholder="Search....." (keyup)="applyFilter($event)" />
      </div>
    </div>

    <div class="d-flex gap-4 border-bottom border-secondary mt-3">
      <div
        class="tab-item fs-14 fw-bold font-white pb-2 position-relative"
        [class.active]="selectedTab === 'region'"
        (click)="onTabChange('region')"
        tabindex="0"
        (keydown.enter)="onTabChange('region')"
        (keydown.space)="onTabChange('region')">
        <div class="px-3">REGION</div>
        <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
      </div>

      <!-- <div
        class="tab-item fs-14 fw-bold font-white pb-2 position-relative"
        [class.active]="selectedTab === 'city'"
        (click)="onTabChange('city')"
        tabindex="0"
        (keydown.enter)="onTabChange('city')"
        (keydown.space)="onTabChange('city')">
        <div class="px-3">CITY</div>
        <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
      </div> -->

      <div
        class="tab-item fs-14 fw-bold font-white pb-2 position-relative"
        [class.active]="selectedTab === 'area'"
        (click)="onTabChange('area')"
        tabindex="0"
        (keydown.enter)="onTabChange('area')"
        (keydown.space)="onTabChange('area')">
        <div class="px-3">AREA</div>
        <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
      </div>
    </div>

    <div class="text-white mt-3">
      <div *ngIf="selectedTab === 'region'">
        <table mat-table [dataSource]="regionDataSource" matSort multiTemplateDataRows class="w-100" style="border-collapse: separate; border-spacing: 0 0px">
          <!-- City Row (Main Card) -->
          <ng-container matColumnDef="card">
            <th mat-header-cell *matHeaderCellDef class="--width-2"></th>
            <td mat-cell *matCellDef="let region">
              <div class="bg-gray border-radius-10 d-flex justify-content-between align-items-center p-3 mb-0">
                <!-- Left: City Info -->
                <div class="d-flex flex-column flex-md-row align-items-start">
                  <div [innerHtml]="SVG_ICONS.LOCATION_ICON() | sanitizer : 'html'"></div>
                  <div class="ms-md-2 mt-2 mt-md-0">
                    <div class="fs-12 fw-normal font-white">Region Name</div>
                    <p class="font-white fs-16 fw-bold mb-0">{{ region.RegionName }}</p>
                  </div>
                </div>

                <!-- Right: Stats + Expand -->
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-start me-4 mb-2">
                    <div [innerHtml]="SVG_ICONS.FLAG_ICON() | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fs-12 fw-normal font-gray">Area</div>
                      <p class="font-white fs-16 fw-bold mb-0">{{ region.AreaCount }}</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-start me-4 mb-2">
                    <div [innerHtml]="SVG_ICONS.CLASSES_ARROW('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fs-12 fw-normal font-gray">Centers</div>
                      <p class="font-white fs-16 fw-bold mb-0">{{ region.CenterCount }}</p>
                    </div>
                  </div>
                  <!-- <div class="d-flex align-items-start me-4 mb-2">
                    <div [innerHtml]="SVG_ICONS.COACH_ARROW('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fs-12 fw-normal font-gray">Members</div>
                      <p class="font-white fs-16 fw-bold mb-0">52</p>
                    </div>
                  </div> -->
                  <div class="me-2">
                    <div class="d-flex gap-4">
                      <div
                        [innerHtml]="expandedElement === region ? (SVG_ICONS.EYE_CROSS_ICON() | sanitizer : 'html') : (SVG_ICONS.EYE_ICON() | sanitizer : 'html')"
                        class="arrow-container cursor-pointer"
                        (click)="toggleRegion(region)"
                        tabindex="0"
                        (keydown.enter)="toggleRegion(region)"
                        (keydown.space)="toggleRegion(region)"
                        (keydown.tab)="toggleRegion(region)"></div>
                      <div>
                        <div
                          [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"
                          class="arrow-container cursor-pointer"
                          (click)="onClickRegion(region)"
                          tabindex="0"
                          (keydown.enter)="onClickRegion(region)"
                          (keydown.space)="onClickRegion(region)"
                          (keydown.tab)="onClickRegion(region)"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="Expand">
            <th mat-header-cell *matHeaderCellDef class="--width-2"></th>
            <td mat-cell *matCellDef="let row">
              <div class="city-card">
                <button mat-icon-button (click)="toggleCity(row)">
                  <div class="">
                    <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"></div>
                  </div>
                </button>
              </div>
            </td>
          </ng-container> -->

          <!-- Expanded Centers -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
              <div *ngIf="expandedElement === row" class="expanded-wrapper">
                <div *ngFor="let center of centerList" class="p-2 border-radius-5 bg-card d-flex justify-content-between align-items-center">
                  <!-- Left: Center Info -->
                  <div class="d-flex align-items-center">
                    <div [innerHtml]="SVG_ICONS.FLAG_ICON() | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fw-bold text-white">{{ center.CenterName }}</div>
                      <small class="text-light">{{ center.Address }}</small>
                    </div>
                  </div>

                  <!-- Right: Stats -->
                  <div class="d-flex align-items-center">
                    <div class="me-4">
                      <div class="fs-12 fw-normal font-gray-opacity">Classes</div>
                      <div class="fs-16 fw-bold font-white">{{ center.classCount }}</div>
                    </div>
                    <div class="me-4">
                      <div class="fs-12 fw-normal font-gray-opacity">Coaches</div>
                      <div class="fs-16 fw-bold font-white">{{ center.trainerCount }}</div>
                    </div>
                    <div class="me-4">
                      <div class="fs-12 fw-normal font-gray-opacity">Members</div>
                      <div class="fs-16 fw-bold font-white">{{ center.studentCount }}</div>
                    </div>
                    <button mat-icon-button (click)="onClick(center.CenterID)">
                      <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"></div>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="city-row"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" [@detailExpand]="expandedElement === row ? 'expanded' : 'collapsed'"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [length]="Pagelength" showFirstLastButtons class="mt-3"></mat-paginator>
      </div>

      <div *ngIf="selectedTab === 'area'">
        <table mat-table [dataSource]="areaDataSource" matSort multiTemplateDataRows class="w-100" style="border-collapse: separate; border-spacing: 0 0px">
          <!-- City Row (Main Card) -->
          <ng-container matColumnDef="card">
            <th mat-header-cell *matHeaderCellDef class="--width-2"></th>
            <td mat-cell *matCellDef="let region">
              <div class="bg-gray border-radius-10 d-flex justify-content-between align-items-center p-3">
                <!-- Left: City Info -->
                <div class="d-flex flex-column flex-md-row align-items-start">
                  <div [innerHtml]="SVG_ICONS.FLAG_ICON('var(--font-color-white)') | sanitizer : 'html'"></div>
                  <div class="ms-md-2 mt-2 mt-md-0">
                    <div class="fs-12 fw-normal font-white">Area Name</div>
                    <p class="font-white fs-16 fw-bold mb-0">{{ region.AreaName }}</p>
                  </div>
                </div>

                <!-- Right: Stats + Expand -->
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-start me-4 mb-2">
                    <div [innerHtml]="SVG_ICONS.CENTER_ICON('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fs-12 fw-normal font-gray">Centers</div>
                      <p class="font-white fs-16 fw-bold mb-0">{{ region.CenterCount }}</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-start me-4 mb-2">
                    <div [innerHtml]="SVG_ICONS.CLASSES_ARROW('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fs-12 fw-normal font-gray">Centers</div>
                      <p class="font-white fs-16 fw-bold mb-0">{{ region.CenterCount }}</p>
                    </div>
                  </div>
                  <!-- <div class="d-flex align-items-start me-4 mb-2">
                    <div [innerHtml]="SVG_ICONS.COACH_ARROW('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fs-12 fw-normal font-gray">Members</div>
                      <p class="font-white fs-16 fw-bold mb-0">52</p>
                    </div>
                  </div> -->
                  <div class="d-flex gap-4">
                    <div
                      [innerHtml]="expandedElement === region ? (SVG_ICONS.EYE_CROSS_ICON() | sanitizer : 'html') : (SVG_ICONS.EYE_ICON() | sanitizer : 'html')"
                      class="arrow-container cursor-pointer"
                      (click)="toggleArea(region)"
                      tabindex="0"
                      (keydown.enter)="toggleArea(region)"
                      (keydown.space)="toggleArea(region)"
                      (keydown.tab)="toggleArea(region)"></div>
                    <div>
                      <div
                        [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"
                        class="arrow-container cursor-pointer"
                        (click)="onClickArea(region)"
                        tabindex="0"
                        (keydown.enter)="onClickArea(region)"
                        (keydown.space)="onClickArea(region)"
                        (keydown.tab)="onClickArea(region)"></div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="Expand">
            <th mat-header-cell *matHeaderCellDef class="--width-2"></th>
            <td mat-cell *matCellDef="let row">
              <div class="city-card">
                <button mat-icon-button (click)="toggleCity(row)">
                  <div class="">
                    <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"></div>
                  </div>
                </button>
              </div>
            </td>
          </ng-container> -->

          <!-- Expanded Centers -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
              <div *ngIf="expandedElement === row" class="expanded-wrapper">
                <div *ngFor="let center of centerList" class="p-2 border-radius-5 bg-card d-flex justify-content-between align-items-center">
                  <!-- Left: Center Info -->
                  <div class="d-flex align-items-center">
                    <div [innerHtml]="SVG_ICONS.FLAG_ICON() | sanitizer : 'html'"></div>
                    <div class="ms-2">
                      <div class="fw-bold text-white">{{ center.CenterName }}</div>
                      <small class="text-light">{{ center.Address }}</small>
                    </div>
                  </div>

                  <!-- Right: Stats -->
                  <div class="d-flex align-items-center">
                    <div class="me-4">
                      <div class="fs-12 fw-normal font-gray-opacity">Classes</div>
                      <div class="fs-16 fw-bold font-white">{{ center.classCount }}</div>
                    </div>
                    <div class="me-4">
                      <div class="fs-12 fw-normal font-gray-opacity">Coaches</div>
                      <div class="fs-16 fw-bold font-white">{{ center.trainerCount || 0 }}</div>
                    </div>
                    <div class="me-4">
                      <div class="fs-12 fw-normal font-gray-opacity">Members</div>
                      <div class="fs-16 fw-bold font-white">{{ center.studentCount || 0 }}</div>
                    </div>
                    <button mat-icon-button (click)="onClick(center.CenterID)">
                      <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"></div>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="city-row"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" [@detailExpand]="expandedElement === row ? 'expanded' : 'collapsed'"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [length]="Pagelength" showFirstLastButtons class="mt-3"></mat-paginator>
      </div>
      <!-- <div class="fs-14 fw-bold font-white mb-3 mt-3">Centers</div> -->
      <!-- 
    @for(item of centerList; track $index) {
    <div class="card bg-card p-3 border-radius-10 mb-2">
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="d-flex flex-column flex-md-row align-items-start">
          <div [innerHtml]="SVG_ICONS.HOME_ICON() | sanitizer : 'html'"></div>
          <div class="ms-md-2 mt-2 mt-md-0">
            <div class="fs-14 fw-bold font-white">
              {{ item.CenterName }}
            </div>
            <p class="font-white fs-12 fw-normal mb-0">{{ item.Address }}</p>
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-start justify-content-md-end mt-3 mt-md-0">
          <div class="d-flex align-items-start me-4 mb-2">
            <div [innerHtml]="SVG_ICONS.CLASSES_ARROW('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
            <div class="ms-2">
              <div class="fs-12 fw-normal font-gray">Classes</div>
              <p class="font-white fs-16 fw-bold mb-0">52</p>
            </div>
          </div>
          <div class="d-flex align-items-start me-4 mb-2">
            <div [innerHtml]="SVG_ICONS.COACH_ARROW('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
            <div class="ms-2">
              <div class="fs-12 fw-normal font-gray">All Coaches</div>
              <p class="font-white fs-16 fw-bold mb-0">52</p>
            </div>
          </div>
          <div class="d-flex align-items-start me-4 mb-2">
            <div [innerHtml]="SVG_ICONS.MEMBER_ICON('var(--font-color-gray)', 36, 36) | sanitizer : 'html'"></div>
            <div class="ms-2">
              <div class="fs-12 fw-normal font-gray">All Members</div>
              <p class="font-white fs-16 fw-bold mb-0">52</p>
            </div>
          </div>
          <div class="mt-2 ms-md-3">
            <div
              [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"
              (click)="onClick(item.CenterID)"
              class="cursor-pointer"
              (keydown.enter)="onClick(item)"
              (keydown.space)="onClick(item)"
              tabindex="0"
              role="button"></div>
          </div>
        </div>
      </div>
    </div>
    } -->
    </div>
  </div>
</div>
